<template>
  <div>
    <vs-popup class="user-edit-popup"
            id="popup"
            title="CREATE BUDGET TOOL"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form autocomplete="off" @submit.prevent="handleSubmit(submitChanges)">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="customers" name="customers" rules="required"
                                  v-slot="{ errors }">
                <small class="label">Customer</small>
                <vs-input class="w-full" name="value" type="text" v-model="customer_data.company_name"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="" name="customers" rules="required"
                                  v-slot="{ errors }">
                <small class="label">Time Interval</small>
                <vs-input class="w-full" name="value" type="text" v-model="forecast_tool_time_interval"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-for="(tool, index_tool) in budget_tools" :key="index_tool">
            <div class="vx-col w-full">
              <vx-card-custom :card-border="true" :remove-card-action="true" v-on:remove="onRemoveCard(index_tool)" >
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="`${index_tool}formulations`" :name="`${index_tool}formulations`" rules="required"
                                        v-slot="{ errors }">
                      <small class="label mb-2">Finished Product</small>
                      <v-select :clearable="false" name="formulations" placeholder="" label="formulation_code"
                                v-model="tool.formulation_id"
                                :options="formulations"
                                :reduce="option => option.id"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />
                      <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider :vid="`${index_tool}financial_year`" :name="`${index_tool}financial_year`" rules="required"
                                        v-slot="{ errors }">
                      <small class="label mb-2">Financial Year</small>
                      <v-select :clearable="false" name="financial_year" placeholder="" label="value"
                                v-model="financial_year"
                                :options="f_y_arr"
                                :reduce="option => option.key"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      />
                      <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vx-card subtitle="Items">
                      <table class="full-page-bg-color" border="0">
                        <thead>
                        <tr>
                          <th width="30%" class="head text-center">Period ({{ forecast_tool_time_interval }})</th>
                          <th width="30%" class="head text-center">Value (Kg)</th>
                          <th width="30%" class="head text-center">Amount (GBP)</th>
                          <th width="10%" class="head text-center"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style="cursor: pointer; z-index: 100" :key="index_item"
                            v-for="(item, index_item) in tool.items">
                          <td>
                            <ValidationProvider :vid="`${index_tool}${index_item}date`" :name="`${index_tool}${index_item}date`"
                                                v-slot="{ errors }" rules="required">
                              <flat-pickr disabled class="w-full" :config="flatPkrConfig" v-model="item.date" placeholder="Choose Date" />
                              <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider :vid="`${index_tool}${index_item}value`" :name="`${index_tool}${index_item}value`" rules="required"
                                                v-slot="{ errors }">
                              <vs-input class="w-full" name="value" type="text" v-model="item.value"
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider :vid="`${index_tool}${index_item}amount`" :name="`${index_tool}${index_item}amount`" rules="required"
                                                v-slot="{ errors }">
                              <vs-input class="w-full" name="amount" type="text" v-model="item.amount"
                                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                            </ValidationProvider>
                          </td>
                          <td v-if="tool.items.length - 1 === index_item">
                            <vs-button @click="onClickRemoveItem(index_tool, index_item)" icon-pack="feather" icon="icon-trash-2" class="shadow-sm" color="danger"
                                       size="small">
                            </vs-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                    </vx-card>
                  </div>
                </div>
                <div class="mb-2 vx-row">
                  <div class="w-full vx-col md:w-1/2 md:mb-0 mt-5">
                    <vs-button @click="onClickAddNewItem(index_tool)" icon-pack="feather" icon="icon-plus" class="shadow-sm" color="success"
                               size="small">
                      Add Another Period
                    </vs-button>
                  </div>
                </div>
              </vx-card-custom>
            </div>
          </div>

          <div class="mb-2 vx-row">
            <div class="w-full vx-col md:w-1/2 md:mb-0 mt-5">
              <vs-button @click="onClickAddNewProduct" icon-pack="feather" icon="icon-plus" class="shadow-sm" color="success"
                         size="small">
                Add New Product
              </vs-button>
            </div>
          </div>


          <!--            <vs-row class="mt-8">-->
          <!--              <div class="vx-col w-full">-->
          <!--              <table class="full-page-bg-color" border="0">-->
          <!--                <thead>-->
          <!--                <tr>-->
          <!--                  <th class="head">DATE</th>-->
          <!--                  <th class="head">VALUE</th>-->
          <!--                </tr>-->
          <!--                </thead>-->
          <!--                <tbody>-->
          <!--                  <tr style="cursor: pointer; z-index: 100" :key="index" v-for="(tr, index) in items">-->
          <!--                    <td>-->
          <!--                     <ValidationProvider :vid="`${index}date`" :name="`${index}date`" :rules="checkDate(index)"-->
          <!--                                        v-slot="{ errors }">-->
          <!--                       <flat-pickr class="w-full" :config="flatPkrConfig" v-model="items[index].date" placeholder="Choose Date" />-->
          <!--                       <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>-->
          <!--                     </ValidationProvider>-->
          <!--                    </td>-->
          <!--                    <td>-->
          <!--                      <ValidationProvider :vid="`${index}value`" :name="`${index}value`" rules="required"-->
          <!--                                        v-slot="{ errors }">-->
          <!--                        <vs-input class="w-full" name="value" type="text" v-model="items[index].value"/>-->
          <!--                        <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>-->
          <!--                      </ValidationProvider>-->
          <!--                    </td>-->
          <!--                  </tr>-->
          <!--                </tbody>-->
          <!--              </table>-->
          <!--              </div>-->
          <!--            </vs-row>-->

          <!--            <div class="mb-2 vx-row">-->
          <!--              <div class="w-full vx-col md:w-1/2 md:mb-0 mt-5">-->
          <!--                <vs-button @click="addCard" icon-pack="feather" icon="icon-plus" class="shadow-sm" color="success"-->
          <!--                           size="small">-->
          <!--                  Add New Item-->
          <!--                </vs-button>-->
          <!--              </div>-->
          <!--            </div>-->

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button class="ml-auto mt-2" button="submit">Create</vs-button>
          </div>
        </form>
      </ValidationObserver>

    </vs-popup>
</div>


</template>

<script>
import vSelect from 'vue-select'
import moment from "moment";
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from '@/mixins/ErrorMessages';
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

const FormulationsRepository = RepositoryFactory.get('formulations')
const CustomerRepository = RepositoryFactory.get('customer')
const SettingsRepository = RepositoryFactory.get('settings');
const BudgetToolRepository = RepositoryFactory.get('budget_tool');
const DropDownRepository = RepositoryFactory.get('drop_down')

function initialState() {
  return {
    open: false,
    time_interval: null,
    unit: null,
    formulation_id: null,
    customer_data: {
      company_name: '',
      id: ''
    },
    budget_tools: [
      {
        formulation_id: '',
        items: [
          {
            date: '',
            value: '',
            amount: ''
          }
        ]
      },
    ],
    financial_year_start_month:'',
    items: [],
    formulations: [],
    customers: [],
    forecast_configs: {
      config_time_interval: '',
    },
    financial_year: moment().year() + '',
    f_y_arr: [
      { key: '2022', value: '2022/2023' },
      { key: '2023', value: '2023/2024' },
      { key: '2024', value: '2024/2025' },
      { key: '2025', value: '2025/2026' },
    ]
  }
}

export default {
  name: "CreateBudgetTool",
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  methods: {
    async openPopup(customer_data) {
      await Object.assign(this.$data, initialState());
      this.open = true
      this.$refs.form.reset()
      this.items = []
      await this.fetchCustomers()
      this.customer_data = customer_data
      await this.fetchFormulations()
      await this.fetchSettings()
      await this.setFirstDate()
      await this.addInitialItems()
      await this.addCard()
    },
    async fetchFormulations() {
      this.$vs.loading();
      try {
        const { data } = (await BudgetToolRepository.getFilteredBudgetToolFormulation(this.customer_data.id)).data
        this.formulations = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCustomers() {
      this.$vs.loading();
      const {data} = await DropDownRepository.getCustomersList()
      this.customers = data.data
      this.$vs.loading.close()
    },
    async fetchSettings() {
      this.$vs.loading();
      const {data} = (await SettingsRepository.getListOfSettings()).data;
      this.financial_year_start_month = data.financial_year_start_month ? data.financial_year_start_month.elements[0].value : '';
      this.forecast_tool_time_interval = data.forecast_tool_time_interval ? data.forecast_tool_time_interval.elements[0].value : '';
      if(this.forecast_tool_time_interval && this.forecast_tool_time_interval !== ''){
        if(this.forecast_tool_time_interval === 'monthly'){
          this.forecast_configs.config_time_interval = 'months'
        }
        if(this.forecast_tool_time_interval === 'weekly') {
          this.forecast_configs.config_time_interval = 'week'
        }
        if(this.forecast_tool_time_interval === 'daily') {
          this.forecast_configs.config_time_interval = 'day'
        }
      }
      this.$vs.loading.close()
    },
    onClickAddNewProduct() {
      this.budget_tools.push(
        {
          formulation_id: '',
          items: [
            {
              date: '',
              value: ''
            }
          ]
        }
      )
      this.setFirstDate(this.budget_tools.length - 1, 0)
      this.addInitialItems(this.budget_tools.length - 1)
    },
    onClickAddNewItem(index) {
      this.addNewItem(index)
    },
    addNewItem(index, value = 0, amount = 0){
      const items_length = this.budget_tools[index].items.length
      let nextDate = ''
      if(items_length >= 1){
        const date = this.budget_tools[index].items[items_length - 1].date
        nextDate = moment(date,'DD/MM/YYYY').add(1,  this.forecast_configs.config_time_interval).format('DD/MM/YYYY')
      }
      this.budget_tools[index].items.push({ date: nextDate, value: value , amount: parseFloat(amount).toFixed(2) })
    },
    async setFirstDate(tool_index = 0, item_index = 0){
      // this.budget_tools[tool_index].items[item_index].date = moment().clone().startOf('month').format('DD/MM/YYYY');
      this.budget_tools[tool_index].items[item_index].date = `01/${moment(this.financial_year_start_month, 'MMMM').format('M')}/${this.financial_year}`
      this.budget_tools[tool_index].items[item_index].value = 0
      this.budget_tools[tool_index].items[item_index].amount = parseFloat(0).toFixed(2)
    },
    addInitialItems(index = 0){
      for(let i=1; i<12; i++){
        this.addNewItem(index)
      }
    },
    addCard() {
      const newObject = {
        date: '',
        value: 0,
        amount: parseFloat(0).toFixed(2)
      }
      this.items.push(newObject)
    },
    onClickRemoveItem(index_tool, index_item) {
      this.budget_tools[index_tool].items.splice(index_item, 1)
    },
    onRemoveCard(index) {
      this.budget_tools.splice(index, 1)
    },
    removeCard(index) {
      this.items.splice(index, 1)
    },
    async submitChanges() {
      this.$vs.loading();
      try {
        const vue = this
        const payload = {
          customer_id: this.customer_data.id,
          budget_tools: this.budget_tools
        }
        await BudgetToolRepository.createBudgetTool(payload)
        await vue.$parent.refreshData()
        this.showSuccessMessage('Budget tool created successfully');
        this.open = false
      } catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    checkDate(item_index){
      let validation = ''
      this.items.map((item, index) => {
        if (index !== item_index) {
          if (this.items[index].date === this.items[item_index].date) {
            validation = `unique_date:${this.items[index].date}`
          }
        }
      })
      return validation;
    }
  },
  computed:{
    flatPkrConfig(){
      const interval = this.time_interval
      return {
        dateFormat: 'd/m/Y',
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: "d/m/Y",
          })
        ],
        enable: [
          function (date) {
            if (interval === 'monthly') {
              return (date.getDate() === 1)
            }
            if (interval === 'weekly') {
              return (date.getDay() === 1)
            }
            return true
          }
        ]
      };
    },
  },
  watch: {
    'financial_year' : function () {
      this.budget_tools =  [
        {
          formulation_id: '',
          items: [
            {
              date: '',
              value: '',
              amount: ''
            }
          ]
        },
      ]
      this.setFirstDate()
      this.addInitialItems()
    }
  }

}
</script>

<style scoped>
.user-edit-popup  >>> .vs-popup  {
  width: 40%;
}

table {
  border-collapse: collapse;
  width: 100%;
}

td, th {
  text-align: left;
  padding: 8px;
}
</style>
